import React from 'react'
import graphQlIcon from '../../assets/icons/graphql.gif';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';


function GraphQLPanel() {
    const { OPERATION } = useSelector(state => state?.treeData?.outbound?.rightTree?.tree?.body?.selectedNode || {})
    const {t} = useTranslation();
    const operationType = t(OPERATION) || t('_GRAPHQL_QUERY_') || '' + '';
    const displayLabel = operationType ? operationType.charAt(0).toUpperCase() + operationType.slice(1) : operationType;
  return (
    <div>
    <div className='divider-bottom flex align-center' style={{padding: '6px 16px', gap: '8px'}}>
        <img src={graphQlIcon} alt="GraphQL" style={{ width:16, height: 16 }} />
        <p>{displayLabel}</p>
    
    </div>
    </div>
  )
}

export default GraphQLPanel